// Corresponds to ConfirmationCodeResult in ConfirmationCode.cs
// Represents possible results of an operation that involves a
// confirmation code from an email

export const CONFIRMATION_CODE_RESULT = {
    success: 0,
    expired: 1,
    incorrectCrossCheckCode: 2,
    incorrectCode: 3,
    incorrectLoginId: 4,
    otherError: 5,
    noMappedPrograms: 6
};
